import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    // Set appropriate inputMode for better mobile keyboard
    const getInputMode = (inputType: string | undefined) => {
      switch (inputType) {
        case 'email': return 'email';
        case 'tel': return 'tel';
        case 'number': return 'numeric';
        case 'url': return 'url';
        case 'search': return 'search';
        default: return 'text';
      }
    };

    return (
      <input
        type={type}
        inputMode={getInputMode(type)}
        className={cn(
          "flex min-h-[44px] w-full rounded-md border border-input bg-background px-4 py-3 text-base ring-offset-background file:border-0 file:bg-transparent file:text-base file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 touch-manipulation",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
